import React from 'react'
import { Container } from 'react-bootstrap'
import Banners from '../components/home/carousel'
import Companies from '../components/home/companies/companies'
import Counter from '../components/home/counter/counter'
import Map from '../components/home/map/map'
import Moto from '../components/home/moto/moto'
import Principles from '../components/home/principles/principles'


export const Home = () => {
  return (
    <div>
      <Banners />
      <Counter/>
      <Container>
        <Principles />
        <Companies />
      </Container>
      <Moto />
      <Map/>
    </div>
  )
}
